import React from "react";
import ApsModels from "../../../../models";
import systemStore from "../../../../stores/SystemStore";
import { FgUseForm, IBasicDialogProps } from "../../../Common/FormGroups";
import { FgInput } from "../../../Common/FormGroups/FgInput";
import FormModal from "../../../Common/FormModal";

function DTCoursesDialog(
  props: IBasicDialogProps<ApsModels.IIsaCourseOutputDto>
) {
  const { registry, handleSubmit, formState } = FgUseForm({
    name: {
      displayName: "Course Name",
      validation: {
        required: true,
        validate: {
          exists: (val: string) => {
            if (props.existingItems) {
              return (
                props.existingItems.filter(
                  (item) =>
                    item.trim().toLowerCase() ===
                    (val || "").trim().toLowerCase()
                ).length === 0
              );
            }
            return true;
          },
        },
      },
    },
  });
  const close = (saved?: boolean) => {
    props.onClose(saved);
  };

  const submit = async (form: ApsModels.IIsaCourseOutputDto) => {
    const data = {
      ...form,
      departmentId: systemStore.currentDrillTemplateDepartment,
      isEnabled: true,
    };
    props.onChange && props.onChange(data);
    close(true);
  };

  return (
    <div>
      <FormModal
        title="New Course"
        isOpen={true}
        close={() => close()}
        submit={handleSubmit(submit)}
      >
        <form onSubmit={handleSubmit(submit)}>
          <FgInput
            id="courseName"
            placeHolder="Course Name"
            registeredField={registry.name}
            formState={formState}
            autoFocus={true}
          ></FgInput>
        </form>
      </FormModal>
    </div>
  );
}

export default DTCoursesDialog;
